/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Basic serializer to pass CustomUser details to the front end.
 * Extend with any fields your app needs.
 * @export
 * @interface PatchedCustomUser
 */
export interface PatchedCustomUser {
    /**
     * 
     * @type {number}
     * @memberof PatchedCustomUser
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    readonly avatarUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUser
     */
    readonly getDisplayName?: string;
}

/**
 * Check if a given object implements the PatchedCustomUser interface.
 */
export function instanceOfPatchedCustomUser(value: object): value is PatchedCustomUser {
    return true;
}

export function PatchedCustomUserFromJSON(json: any): PatchedCustomUser {
    return PatchedCustomUserFromJSONTyped(json, false);
}

export function PatchedCustomUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedCustomUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'avatarUrl': json['avatar_url'] == null ? undefined : json['avatar_url'],
        'getDisplayName': json['get_display_name'] == null ? undefined : json['get_display_name'],
    };
}

  export function PatchedCustomUserToJSON(json: any): PatchedCustomUser {
      return PatchedCustomUserToJSONTyped(json, false);
  }

  export function PatchedCustomUserToJSONTyped(value?: Omit<PatchedCustomUser, 'id'|'avatar_url'|'get_display_name'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'email': value['email'],
    };
}

